// extracted by mini-css-extract-plugin
module.exports = {"container":"container","is-fluid":"is-fluid"};